var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/submissions/components/SubmissionForm/SubmissionFormSets.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/submissions/components/SubmissionForm/SubmissionFormSets.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
var macro_t_4 = runtime.makeMacro(
[], 
["data"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});var t_5 = "";t_5 += "\n    <div class=\"SubmissionFormSets\">\n        <div class=\"SubmissionFormSets-upload\" ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"setsTimingListPdf")) {
t_5 += "data-file=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"setsTimingListPdf"), env.opts.autoescape);
t_5 += "\"";
;
}
t_5 += " data-state=\"idle\">\n            <label class=\"SubmissionFormSets-label SubmissionFormSets-label--big\" for=\"setsTimingListPdf\">Upload Set Timing List</label>\n            <div class=\"SubmissionFormSets-filename\"><span>File Uploaded:&nbsp;</span><a href=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"setsTimingListPdf"), env.opts.autoescape);
t_5 += "\" class=\"u-skipUrlParser\" target=\"_blank\">";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"setsTimingListPdf")) {
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"setsTimingListPdf"), env.opts.autoescape);
;
}
t_5 += "</a></div>\n            <label class=\"SubmissionFormSets-label SubmissionFormSets-label--small\" for=\"setsTimingListPdf\">Upload Set Timing List</label>\n            <input type=\"file\" id=\"setsTimingListPdf\" name=\"setsTimingListPdf\" accept=\".pdf\">\n        </div>\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_5);
});
context.addExport("SubmissionFormSets");
context.setVariable("SubmissionFormSets", macro_t_4);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/submissions/components/SubmissionForm/SubmissionFormSets.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/submissions/components/SubmissionForm/SubmissionFormSets.jinja
// module id = 60
// module chunks = 0